import { action } from 'satcheljs';
import { AttachmentFolderPickerProperties } from '../types/AttachmentFolderPickerProperties';

export const initializeAttachmentFolderPicker = action(
    'initializeAttachmentFolderPicker',
    (properties: AttachmentFolderPickerProperties) => ({ properties })
);
